"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { muteVideoOperation } from "../_operations/muteVideo";

export function MuteVideoContent() {
  return <MediaWorkspace operation={muteVideoOperation} />;
}
